module.exports = __webpack_public_path__ + "img/search.03fe863e.svg";